import { Toast } from '@capacitor/toast'

export default function Alert(message) {
    if (message) {
        Toast.show({
            text: message
        })
    }
}
